<template>
    <el-select v-model="val" :placeholder="$strings('word/select_cp')"
               :class="hclass" size="small" :disabled="disable" clearable filterable>
        <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
    </el-select>
</template>

<script>
import {SpSiteCpRead} from "../../api/spsite/api";

export default {
    name: "filter-cp",
    props: ['hclass', 'value'],
    data() {
        return {
            disable: true,
            options: [],
            val: '',
        }
    },
    created() {
        this.fetchCp();
    },
    watch: {
        val: function (v) {
            this.$emit('input', v);
        },
        value: function (v) {
            this.val = v;
        }
    },
    methods: {
        fetchCp() {
            SpSiteCpRead({page: 1, size: 1000}).then((resp) => {
                this.options = [];
                resp.data.data.rows.forEach((item) => {
                    this.options.push({value: item.cp_id, label: item.cp_name});
                    this.disable = false;
                })
                this.$emit('load', resp.data.data.rows);
            });
        }
    }
}
</script>

<style scoped>

</style>